import { Button, Card, Dropdown } from "react-bootstrap";
import { BsDownload, BsFunnel } from "react-icons/bs";
import { CiImport, CiSearch } from "react-icons/ci";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";

const ActiveUsersSubscription = () => {
    return ( <>
    <div className="container-fluid py-3">
        <div className="fs-6 fw-semibold mb-3">User Management</div>
        <Card body>
            <div className="hstack gap-2">
                <span className="fs-6 fw-semibold">Active Users (4)</span>
                <div className="hstack gap-2 ms-auto">
                    <div className="col-12 col-md-4 col-xl-auto">
                        <div className="search-box border rounded-2">
                            <label htmlFor="empSearch" className="searchbutton fs-16" type="button">
                                <CiSearch />
                            </label>
                            <input type="search" id="empSearch" placeholder="Search Employee"
                            className="searchfield bg-body-tertiary rounded-2" />
                        </div>
                    </div>
                    <Button variant="light"><BsFunnel size={16} className="me-2" /><span>Filters</span></Button>
                    <Button variant="dark"><BsDownload size={16} className="me-2" /><span>Export</span></Button>
                </div>
            </div>
            <div className="tbl-container rounded-table rounded-2 mt-2">
                <div className="table-responsive overflow-y-auto" style={{maxHeight: 'calc(100vh - 160px)'}}>
                    <table className="table mb-0">
                        <thead className="table-header table-light">
                            <tr>
                                <th style={{ minWidth: '30px' }}>
                                    <input name="user-headerCheck" className="form-check-input cursor-pointer" type="checkbox" />
                                </th>
                                <th>NAME</th>
                                <th>EMAIL</th>
                                <th>ROLE</th>
                                <th>LAST ACTIVE</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="user-check-1" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>John Deo</td>
                                <td>John@example.com</td>
                                <td><span className="badge badge-light-pink">Admin</span></td>
                                <td>2 hours ago</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="user-check-2" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>Jaxson Culhane</td>
                                <td>John@example.com</td>
                                <td><span className="badge badge-light-primary">User</span></td>
                                <td>2 hours ago</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="user-check-3" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>Marilyn Siphron</td>
                                <td>John@example.com</td>
                                <td><span className="badge badge-light-primary">User</span></td>
                                <td>2 hours ago</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ minWidth: '30px' }}>
                                    <input name="user-check-4" className="form-check-input cursor-pointer" type="checkbox" />
                                </td>
                                <td>Marley Torff</td>
                                <td>John@example.com</td>
                                <td><span className="badge badge-light-primary">User</span></td>
                                <td>2 hours ago</td>
                                <td>
                                    <div className="hstack gap-2 justify-content-center">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="light"
                                            className="p-1 rounded-circle without-arrow">
                                                <HiOutlineDotsCircleHorizontal size={20} />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Card>
    </div>
    </> );
}
 
export default ActiveUsersSubscription;